import { render, staticRenderFns } from "./CreateMendian.vue?vue&type=template&id=cdd5e272"
import script from "./CreateMendian.vue?vue&type=script&lang=js"
export * from "./CreateMendian.vue?vue&type=script&lang=js"
import style0 from "./CreateMendian.vue?vue&type=style&index=0&id=cdd5e272&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports